import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useContractList = ({ search, status, page }) => {
  if (!status) status = "All";

  const filter = {
    filter: {
      f_Id: "",
      f_selectedType: !status ? "All" : status,
      searchTerm: search,
    },
    paging: { pageIndex: page },
  };

  return useQuery({
    queryKey: ["contractListState", filter],
    queryFn: async () =>
      callApi({
        path: "contractlist",
        command: "",
        data: JSON.stringify({ list: filter }),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};
